import React from "react";
import whatsappIcon from "../../assets/WhatsApp.png";

const Whatsapp = () => {
  const phoneNumber = "+335699766008"; 
  const message = "Hello how can we help you?"; 

  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    message
  )}`;

  return (
    <div>
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
        <img
          style={{
            position: 'fixed',
            width: "80px",
            height: "80px",
            bottom: "80px",
            right: "20px",
          }}
          src={whatsappIcon}
        ></img>
      </a>
    </div>
  );
};

export default Whatsapp;
